const APEX_DOMAIN = (process.env.NEXT_PUBLIC_APEX_DOMAIN || "instacks.co").toLowerCase();

export const getSubdomain = (): string | null => {
  if (typeof window === "undefined") return null;

  const hostname = window.location.hostname.toLowerCase();

  // Localhost handling
  if (hostname.includes("localhost") || hostname === "127.0.0.1") {
    const parts = hostname.split(".");
    // sub.localhost or sub.127.0.0.1 (though 127.0.0.1 usually doesn't have subs)
    if (parts.length >= 2 && parts[parts.length - 1] === "localhost") {
      return parts[0];
    }
    // If it's just localhost:3000, we might want a default or return null
    return null;
  }

  // Apex domain (instacks.co or www.instacks.co) — never a tenant.
  const hostWithoutPort = hostname.split(":")[0];
  if (hostWithoutPort === APEX_DOMAIN || hostWithoutPort === `www.${APEX_DOMAIN}`) {
    return null;
  }

  // Production handling — any host with at least 2 labels is treated as subdomain-bearing.
  // Skip hosts that are just an apex (single label like "gradstreet") or "www".
  const parts = hostWithoutPort.split(".");
  if (parts.length >= 2 && parts[0] && parts[0] !== "www") {
    return parts[0];
  }

  return null;
};
